import { render, staticRenderFns } from "./AirSampleDetail.vue?vue&type=template&id=60eff5f9"
import script from "./AirSampleDetail.vue?vue&type=script&lang=js"
export * from "./AirSampleDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports